module.exports = __webpack_public_path__ + "static/media/homebg-transparent.f8c6042c.png";